import React from "react";
import { NavLink } from "react-router-dom";
import "../index.css";
import "../Sidebar.css"; // new CSS file for sidebar styles

const Sidebar = () => {
  // const storedUser = localStorage.getItem("user");
  // const user = storedUser ? JSON.parse(storedUser) : null;
  // console.log("USER:", user);
  let user = null;

  try {
    const storedUser = localStorage.getItem("user");
    user =
      storedUser && storedUser !== "undefined" ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Error parsing stored user in Sidebar:", error);
    localStorage.removeItem("user"); // cleanup bad value
  }

  console.log("USER:", user);
  return (
    <div className="sidebar border-end bg-white">
      <ul className="nav flex-column mb-4">
        <li className="nav-item">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `nav-link sidebar-item ${isActive ? "active" : ""}`
            }
          >
            <i className="bi bi-speedometer2 icon"></i>
            <span className="text">Dashboard</span>
          </NavLink>
        </li>
        {user && user.type !== 1 && (
          <li className="nav-item">
            <NavLink
              to="/uploads"
              className={({ isActive }) =>
                `nav-link sidebar-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-upload icon"></i>
              <span className="text">Upload Report</span>
            </NavLink>
          </li>
        )}
        {/* {user &&
          (user.name === "admin" ||
            user.name === "swami" ||
            user.name === "ranilakshmi" ||
            user.name === "eswaramurthy" ||
            user.name === "karthikeyan" ||
            user.name === "Kaveesher" ||
            user.name === "Sachin Narkhede" ||
            user.name === "Piyush") && (
            <li className="nav-item">
              <NavLink
                to="/export"
                className={({ isActive }) =>
                  `nav-link sidebar-item ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-file-earmark-excel icon"></i>
                <span className="text">Export Data</span>
              </NavLink>
            </li>
          )} */}
        <li className="nav-item">
          <NavLink
            to="/export"
            className={({ isActive }) =>
              `nav-link sidebar-item ${isActive ? "active" : ""}`
            }
          >
            <i className="bi bi-file-earmark-excel icon"></i>
            <span className="text">Export Data</span>
          </NavLink>
        </li>

        {user && (user.username === "admin" || user.username === "swami@yrgcare.org" || user.username === "pmrnaco@gmail.com") && (
          <li className="nav-item">
            <NavLink
              to="/users"
              className={({ isActive }) =>
                `nav-link sidebar-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-people icon"></i>
              <span className="text">User Management</span>
            </NavLink>
          </li>
        )}

        {/* <li className="nav-item">
          <NavLink
            to="/monitoring-report"
            className={({ isActive }) =>
              `nav-link sidebar-item ${isActive ? "active" : ""}`
            }
          >
            <i className="bi bi-stopwatch icon"></i>
            <span className="text">Monitoring Report</span>
          </NavLink>
        </li> */}
      </ul>
    </div>
  );
};

export default Sidebar;
